<div class="add-product-cart">
    <button mat-icon-button (click)="closeDialog()" class="close-btn">
        <span class="jam jam-close"></span>
    </button>

    <div mat-dialog-content class="dialog-content">
        <div class="product-img">
            <div class="img-container">
                <img *ngIf="data.product.photo_feature == '' || data.product.photo_feature == undefined" src="/assets/img/products/product-04.webp" [alt]="data.product.title" />
                <img *ngIf="data.product.photo_feature != '' && data.product.photo_feature != undefined" [src]="data.product.photo_feature" [alt]="data.product.title" />
            </div>

        </div>

        <div class="product-info">
            <h3 class="product-name">{{ data.product.title }}</h3>
            
            <div class="status-message">
                <div *ngIf="isSending && !isSaved" class="loading-state">
                    <mat-spinner diameter="24"></mat-spinner>
                    <p>Agregando al carrito...</p>
                </div>
                <div *ngIf="isSaved" class="success-state">
                    <p>¡Producto agregado exitosamente!</p>
                </div>
            </div>
        </div>
    </div>

    <div class="dialog-actions">
        <button mat-stroked-button class="btn-secondary" (click)="closeDialog()">
            Seguir navegando
        </button>
        <button *ngIf="isSaved" mat-flat-button class="btn-primary" [routerLink]="['/carrito-de-compras']" (click)="closeDialog()">
            <span class="jam jam-shopping-cart"></span>
            Ver carrito
        </button>
    </div>
</div>
